export const FORWARD_ARROW_SVG =
  'M-0.00299644 4.425L15.9395 4.425L12.4457 0.930998L13.3329 0.0499973L18.334 5.05L13.3329 10.05L12.4517 9.169L15.9395 5.675L-0.0039959 5.675L-0.00299644 4.425Z'

export const BACKWARD_ARROW_SVG =
  'M 18.337 5.6298 H 2.3945 L 5.8883 9.1238 L 5.0011 10.0048 L 0 5.0048 L 5.0011 0.0048 L 5.8823 0.8858 L 2.3945 4.3798 H 18.338 L 18.337 5.6298 Z'
